import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IApplicationModel, IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getApplicationList = (data: IDynamicTableParams) => {
  return instance()
    .post<IApplicationModel[]>('/application/uso/list', data)
    .then((response) => response.data);
};

export const getApplicationAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/application/uso/availableColumns')
    .then((response) => response.data);
};

export const getApplicationAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/application/uso/availableGroupColumns')
    .then((response) => response.data);
};
